import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.sass'],
})
export class ModalAlertComponent  implements OnInit {

  info: any;
  messageString: string = "";
  messageArray: string[] = [];

  constructor(public dialogRef: MatDialogRef<ModalAlertComponent>, @Inject(MAT_DIALOG_DATA) public dataDialog: {type: 1|2, title: string, message: any, icon: "warning" | "success" | "error" | "info" | "question"}) {
    this.info = dataDialog
   }

  ngOnInit(): void {
    if (typeof this.info.message === 'string') {
      this.messageString = this.info.message;
    }
    else {
        this.messageArray = this.info.message;
    }
  }
}
